import { render, staticRenderFns } from "./profile-button.vue?vue&type=template&id=f140bb06&scoped=true"
import script from "./profile-button.vue?vue&type=script&lang=js"
export * from "./profile-button.vue?vue&type=script&lang=js"
import style0 from "./profile-button.vue?vue&type=style&index=0&id=f140bb06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140bb06",
  null
  
)

export default component.exports